module.exports = __webpack_public_path__ + "static/media/icon-4-white.73a96f75.svg";